(() => {
  'use strict';
  if (window.dexelMarketLocalizationLoaded) return;
  window.dexelMarketLocalizationLoaded = true;
  const forms = 'form.dexel-localization[data-dexel-market-form]';
  try {
    sessionStorage.removeItem('dexel:manual-language:v1');
    sessionStorage.removeItem('dexel:localization-transition:v1');
  } catch (_) {}
  document.addEventListener('change', event => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || select.name !== 'country_code') return;
    const form = select.closest(forms);
    if (!form) return;
    const language = form.querySelector('input[name="language_code"]');
    if (language) language.value = 'en';
    form.requestSubmit();
  });
  document.querySelectorAll(`${forms} .dexel-localization-submit`).forEach(button => {
    button.hidden = true;
  });
})();
